import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { NAME as name, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';

export const store = listStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		TableId: [],
	},
	filter: {
		TableId: null as number | null,
	},
	tableSetting: {},
	localState: {},
	rowDetail: null,
	extraActions: {},
	extraGetters: {},
	extraMutations: {},
	props: {
		mode: null,
		filter: {},
		afterRowSelection: () => {},
	},
});
